import { createStore } from "vuex";
import menuList from "./home";
export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    menuList,
  },
});
